import { isStudent } from '../utils';
import { StageStyleMap } from '../../../enums/stage';

export const buildTimelineProps = (block, state) => {

  const { stages: reduxStages = [],currentContestId } = state;

  const { props } = block;

  const enrichedStages = reduxStages.map((stage, index) => {
    const stageConfig = props[stage.name];
    const descriptionKey = isStudent(state) ? stageConfig?.student ?? null : stageConfig?.default ?? null;
    const nameKey = stageConfig?.name ?? StageStyleMap[stage.name]?.text ?? null;
    const hebrewDateKey = stageConfig?.hebrewDate ?? StageStyleMap[stage.name]?.hebrewDate ?? null;
    const icon = stageConfig?.icon ?? StageStyleMap[stage.name]?.icon ?? null;
    const startDate = stageConfig?.overrideStartDate ?? stage.startDate;
    const endDate = stageConfig?.overrideEndDate ?? stage.endDate;
    return {
      ...stage,
      id: stage.id ?? stage.name ?? index,
      descriptionKey,
      nameKey,
      hebrewDateKey,
      icon,
      startDate,
      endDate,
      finalRejected : currentContestId ==='14000' && stage?.name === "VirtualFinalEvent" && window.config.theFinalRejected 
    };
  })


  return {
    id: block.id,
    type: block.type,
    props: {
      title: props.title ?? null,
      stages: enrichedStages,
      logo: props.logo ?? null,
    },
  };
};

